import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import nationalities from '../../../../public/nationalities.json';
import nationalitiesAr from '../../../../public/nationalities-ar.json';
import nationalitiesEs from '../../../../public/nationalities-es.json';
import nationalitiesDe from '../../../../public/nationalities-de.json';
import nationalitiesIt from '../../../../public/nationalities-it.json';
import nationalitiesFr from '../../../../public/nationalities-fr.json';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private translate = inject(TranslateService);
  private router = inject(Router);

  langMap: Record<string, string> = {
    en: 'ENG',
    it: 'ITA',
    es: 'SPN',
    ar: 'ARB',
    fr: 'FRA',
    de: 'GER',
  };

  nationalitiesMap: Record<string, { code: string; nationality: string }[]> = {
    en: nationalities,
    ar: nationalitiesAr,
    es: nationalitiesEs,
    de: nationalitiesDe,
    it: nationalitiesIt,
    fr: nationalitiesFr,
  };

  uiLang = signal<string>(localStorage.getItem('uiLang') || 'en');
  dataLang = signal<string>(localStorage.getItem('dataLang') || 'en');

  setUiLang(lang: string) {
    this.updateUiLang(lang);
  }

  setDataLang(lang: string) {
    this.updateUiLang(lang);
    this.dataLang.set(lang);
    localStorage.setItem('dataLang', lang);
  }

  /** at startup: the language of the URL (?lang=) or the last one used; done when its translations are loaded */
  init(): Observable<unknown> {
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    const lang = urlLang && urlLang in this.langMap ? urlLang : this.uiLang();
    return this.updateUiLang(lang);
  }

  updateUiLang(lang: string): Observable<unknown> {
    const loaded = this.translate.use(lang);
    this.uiLang.set(lang);
    localStorage.setItem('uiLang', lang);
    return loaded;
  }

  updateUrl(lang: string) {
    const urlLang = this.router.parseUrl(this.router.url).queryParams['lang'];
    if (urlLang !== lang) {
      this.router.navigate([], {
        queryParams: { lang },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
  }

  get backendLang() {
    return this.langMap[this.uiLang()] || 'ENG';
  }
}
